// Simple, privacy-friendly device fingerprint
// Uses non-invasive attributes to distinguish browsers/devices
// Note: This is best-effort and not guaranteed unique

function hashString(input: string): string {
  let h1 = 0xdeadbeef ^ input.length
  let h2 = 0x41c6ce57 ^ input.length
  for (let i = 0; i < input.length; i++) {
    const ch = input.charCodeAt(i)
    h1 = Math.imul(h1 ^ ch, 2654435761)
    h2 = Math.imul(h2 ^ ch, 1597334677)
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507)
  h2 = Math.imul(h2 ^ (h2 >>> 13), 3266489909)
  h1 ^= h2 >>> 16
  h2 ^= h1 >>> 16
  return (h1 >>> 0).toString(16) + (h2 >>> 0).toString(16)
}

export function getDeviceFingerprint(): string {
  try {
    const nav = navigator
    const screenInfo = `${screen.width}x${screen.height}@${(window.devicePixelRatio || 1).toFixed(2)}`
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
    const langs = Array.isArray(nav.languages) ? nav.languages.join(',') : (nav.language || '')
    const ua = nav.userAgent
    const platform = (nav.platform || '') + (nav.hardwareConcurrency || '')
    const vendor = nav.vendor || ''
    const canvasSupport = typeof HTMLCanvasElement !== 'undefined' ? '1' : '0'
    const touch = 'ontouchstart' in window ? '1' : '0'

    const source = [ua, langs, tz, screenInfo, platform, vendor, canvasSupport, touch].join('|')
    return hashString(source)
  } catch {
    // Fallback to random value (not ideal, but ensures modal shows for first visit)
    return hashString(String(Math.random()))
  }
}

export const DEVICE_STORAGE_KEY = 'travel_warehouse_device_fp'

export function getOrCreateStoredFingerprint(): { fingerprint: string; isNew: boolean } {
  const stored = localStorage.getItem(DEVICE_STORAGE_KEY)
  if (stored && typeof stored === 'string' && stored.length > 8) {
    return { fingerprint: stored, isNew: false }
  }
  const fp = getDeviceFingerprint()
  localStorage.setItem(DEVICE_STORAGE_KEY, fp)
  return { fingerprint: fp, isNew: true }
}
